// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "BusinessProGuestLazyComponent" + "." + "89553d33d3e3ae5b" + ".css"
}